import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../helper/_cookieHelper';
const RequireAuth = ({ children }) => {
    const location = useLocation();
    const isAuth = getCookie("__templateID")
    if (!isAuth) {
        return <Navigate to='/not-found' state={{ from: location }} replace />;
    }
    return children;
};

export default RequireAuth;
